import { STANDARD_TIME_FORMAT } from '@react3l/react3l/config/consts';
/**
 * Vietnamese date format
 *
 * @type {string}
 */
export var VIETNAMESE_DATE_FORMAT = 'DD/MM/YYYY';
/**
 * Vietnamese date-time format
 *
 * @type {string}
 */
export var VIETNAMESE_DATE_TIME_FORMAT = VIETNAMESE_DATE_FORMAT + " " + STANDARD_TIME_FORMAT;
//# sourceMappingURL=vietnamese.js.map